import { render } from "./References.vue?vue&type=template&id=f4993cba&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"

import "./References.vue?vue&type=style&index=0&id=f4993cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4993cba"]])

export default __exports__